import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
export function Team() {
  const team = [{
    name: 'Thessaly Voss',
    role: 'Founder & Chief Strategist',
    bio: 'Former edtech growth lead with a decade in organic acquisition.',
    initials: 'TV',
    color: 'bg-lavender-200 text-lavender-900'
  }, {
    name: 'Caspian Elridge',
    role: 'Head of Technical SEO',
    bio: 'Obsessed with crawl budgets, schema markup, and site architecture.',
    initials: 'CE',
    color: 'bg-sage-200 text-sage-900'
  }, {
    name: 'Isolde Maren',
    role: 'Content Director',
    bio: 'Writes content that ranks and resonates with lifelong learners.',
    initials: 'IM',
    color: 'bg-rose-200 text-rose-900'
  }, {
    name: 'Leander Quill',
    role: 'Analytics Lead',
    bio: 'Turns search data into actionable enrollment growth strategies.',
    initials: 'LQ',
    color: 'bg-blue-200 text-blue-900'
  }];
  return <section id="team" className="py-24 md:py-32 bg-white" data-id="element-156">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-157">
        <FadeIn className="text-center max-w-3xl mx-auto mb-20" data-id="element-158">
          <h2 className="text-sm font-bold tracking-widest text-blue-800 uppercase mb-4" data-id="element-159">
            Our Experts
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-slate-900 leading-tight mb-6" data-id="element-160">
            The Minds Behind Cyberspire
          </h3>
          <p className="text-lg text-slate-600" data-id="element-161">
            A specialized collective of educators turned marketers, dedicated to
            elevating the standard of e-learning discovery.
          </p>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12" data-id="element-162">
          {team.map((member, idx) => <StaggerItem key={idx} className="text-center group" data-id="element-163">
              <div className="mb-6 relative inline-block" data-id="element-164">
                <div className={`w-32 h-32 md:w-40 md:h-40 mx-auto rounded-full flex items-center justify-center text-3xl md:text-4xl font-serif transition-transform duration-500 group-hover:scale-105 ${member.color}`} data-id="element-165">
                  {member.initials}
                </div>
                {/* Decorative ring */}
                <div className="absolute inset-0 rounded-full border border-slate-200 scale-110 opacity-0 group-hover:opacity-100 transition-all duration-500" data-id="element-166" />
              </div>
              <h4 className="text-xl font-serif font-medium text-slate-900 mb-1" data-id="element-167">
                {member.name}
              </h4>
              <p className="text-sm font-medium text-slate-500 uppercase tracking-wider mb-4" data-id="element-168">
                {member.role}
              </p>
              <p className="text-slate-600 leading-relaxed text-sm max-w-xs mx-auto" data-id="element-169">
                {member.bio}
              </p>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}